import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TeButton, TeContainer, TePlaceholder, TeText } from '@topcon/tuicl-react';

import { useExperienceFragment } from '../../components/AssetService/useExperienceFragmentModel';
import {
  BannerVM,
  resolveAEMAssetUrl,
  selectBanner,
} from '../../components/AssetService/asset-service';

const BANNER_HEIGHT = '320px';

function Banner({ path = 'banner' }: { path?: string }) {
  const { t } = useTranslation('common');
  const {
    data: BannerData,
    isLoading,
    error,
  } = useExperienceFragment<BannerVM>({
    path,
    select: selectBanner,
  });

  const { title, pretitle, description, linkUrl, imagePath } = BannerData || {};

  const bgUrl = useMemo(() => {
    if (!imagePath) return undefined;
    return resolveAEMAssetUrl(imagePath);
  }, [imagePath]);

  if (error) return;

  if (isLoading || !BannerData) {
    return (
      <TeContainer fill column padding={0} width="100%" height={BANNER_HEIGHT}>
        <TePlaceholder />
      </TeContainer>
    );
  }

  return (
    <TeContainer
      fill
      column
      padding={0}
      width="100%"
      height={BANNER_HEIGHT}
      justifyContent="flex-end"
      style={{
        background: `center/cover no-repeat url("${bgUrl}")`,
      }}
    >
      <TeContainer column alignItems="flex-start" padding={32} gap={24}>
        <TeText size={32} weight={800} color="text.inverse">
          {pretitle}
        </TeText>

        <TeText size={24} weight={700} color="text.inverse">
          {title}
        </TeText>

        <TeText
          size={14}
          weight={400}
          style={{ display: 'block', maxWidth: '60%' }}
          color="text.inverse"
        >
          {description}
        </TeText>

        <TeButton
          teclick={() => window.open(linkUrl, '_blank', 'noopener,noreferrer')}
          text={t('learnMore')}
        />
      </TeContainer>
    </TeContainer>
  );
}

export default Banner;
